import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import { epoch, utc } from '../../util/datetime';
import type { ITicketIntegrationHistory } from './TicketIntegrationHistory.interface';

export default class TicketIntegrationHistory implements ITicketIntegrationHistory {
  id: string;
  idOwner: string;
  name: string;
  timeStamp: number;

  static build = (data: ITicketIntegrationHistory) => new TicketIntegrationHistory(data);
  static blank = () => new TicketIntegrationHistory({ id: uuid(), timeStamp: epoch(utc()) });

  /**
   * Constructor
   * @param {ITicketIntegrationHistory} data
   */
  constructor(data?: ITicketIntegrationHistory) {
    this.id = toUUID(data?.id) || uuid();
    this.idOwner = toUUID(data?.idOwner);
    this.name = data?.name || '';
    this.timeStamp = epoch(utc(data?.timeStamp));
  }
}
